<template>
  <div class="sjcj">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">智能驾驶</div>
          <div class="t22">
            行业领先的标注平台和全面的数据服务，支持智能座舱和自动驾驶数据需求
          </div>
          <div class="btn1" style="margin: 0 auto;" @click="go('/callMe')">咨询智能驾驶数据方案</div>
        </div>
      </div>
    </div>
    <div class="w1280" style="margin: 48px auto;">
      <div class="flexs">
        <div style="width: 48%;">
          <div class="title-1">为更加舒适的驾乘体验提供数据支持</div>
          <div class="title-2">我们有将近三十年的人工智能数据服务经验，为您的智能驾驶AI提供全面的数据支持。zqLinx AI企业级高精度数据标注平台支持2D图像3D点云多种标注工具，三大交付中心，千人以上规模，立志于为客户提供低成本、高质量的数据服务。</div>
          <div class="title-2">选择我们的理由：</div>
          <ul>
            <li>自主研发的高效平台以及辅助标注工具，涵盖了图像、点云，可同时供万人规模标注，保证了效率并提高了产能</li>
            <li>拥有多年的服务经验及管理经验，确保交付周期并高质量</li>
            <li>和OEM、Tire1、硬件商、等不同纬度的自动驾驶客户均有合作，项目经验丰富</li>
            <li>数据安全有所保障，已获得ISO 27001 、ISO9001和ISO 27701证书</li>
            <li>多种交付模式，满足客户做好不同阶段的诉求</li>
          </ul>
        </div>
        <div style="width: 48%;">
          <img style="width: 100%;border-radius:16px" src="../assets/img/sjfw/r1.webp" alt="">
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">应用场景：智能座舱和自动驾驶</div>
      
      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;">
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <img
              style="width: 405px;height: 192px;border-radius:8px 8px 0 0;object-fit: cover; object-position: top;"
              :src="item.img"
              alt=""
            />
            <div class="contents">
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">数据解决方案</div>
      <div class="slogan">提供全面的数据采集和标注服务，涵盖全球多国家地区以及多语言，支持您的智能驾舱及自动驾驶项目落地及优化。</div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">数据采集定制服务</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>驾驶员危险行为视频采集</li>
                  <li>舱内语音、噪音、婴儿声音采集</li>
                  <li>舱内遗留物品采集</li>
                  <li>方言及多语言指令词定制采集</li>
                  <li>海外路采</li>
                </ul>
              </div>
              <div style="width: 50%;">
                
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              咨询智能驾驶数据解决方案
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/f1.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/a5.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">数据标注定制服务</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>2D3D融合标注</li>
                  <li>3D点云连续帧标注</li>
                  <li>多传感器融合标注</li>
                  <li>4D标注</li>
                  <li>障碍物标注和连续帧跟踪</li>
                  <li>驾乘行为标注</li>
                  <li>人脸识别标注</li>
                </ul>
              </div>
              <div style="width: 50%;">
               
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
          
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">自动驾驶长期项目交付能力</div>
            <div style="line-height: 1.5;font-size: 18px;margin-bottom: 48px;">我们利用zqLinx AI企业高精度数据标注平台的多组AI辅助标注工具，以及三大交付中心，搭建起可以承载大量需求的高效交付团队，为您提供低成本、高质量的数据服务。</div>
            <div class="btn1" @click="go('/callMe')">
              了解交付能力
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/p3.gif"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">我们的优势</div>
      <div class="w1280" style="">
        <div class="flexs" style="flex-wrap: wrap;margin:32px 128px">
          <div class="card-ys" v-for="(item, index) in ysList" :key="index">
            <img style="width:48px;height:48px;margin-bottom:8px" :src="item.img" alt="" />
            <div class="t1">{{item.name}}</div>
            <div class="t2">{{item.content}}</div>
          </div>
        </div>
      </div>
      </div>
    <div class="card-footer">
      <div class="t1">大规模智能驾驶数据</div>
      <div class="t2">高效标注工具与算法支持您的大规模数据需求</div>
      <div class="btns" @click="go('/callMe')">联系我们</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ysList:[
        {
          name: "专业经验",
          content:
            "已经成功交付智能驾驶领域的多方面需求与项目，数十位拥有PMP证书的领域精通项目经理为您的项目进度保驾护航。",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "大规模数据交付能力",
          content:
            "海内外拥有上百万众包，同时有数千位内部标注员与多个自有与合作基地，支持20万+的周交付能力。",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "质量交付",
          content:
            "高质量数据已经服务过数百个项目并维持99%的平均初始数据通过率。",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "数据安全",
          content:
            "通过了ISO27001,ISO9001与ISO27701，以及EHS证书，同时搭建了多个合规室/安全屋，同时有1000+内部标注员为您的高安全要求提供支持。",
          img: require("../assets/img/sjfw/e4.svg"),
        },],
      cardList1: [
        {
          name: "数据存储与传输",
          list:[{t:'国安级加密云技术保证数据传输和存储安全'},{t:'业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'}],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
         list:[{t:'项目现场配置人脸识别和指纹门禁'},{t:'设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'},{t:'配有24*7值班人员以及无死角摄像头监控现场'}],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list:[{t:'标注人员及供应商签署保密协议'},{t:'全体员工办公设备均统一管理'}],
          img: require("../assets/img/sjfw/x3.svg"),
        }
      ],
      cardList: [
        {
          title: "车载语音交互系统",
          img: require("../assets/img/sjfw/a1.webp"),
          textList: [
            {
              title: "",
              content: "我们提供智能座舱内的语音、方言及口音、噪音、唤醒词、指令用语、婴儿及宠物声音等定制化数据采标服务，以及语音合成的多声线多语言支持，帮助您快速构建强大的互动性智能座舱。",
            }
          ],
        },
        {
          title: "DMS系统",
          img: require("../assets/img/sjfw/a2.webp"),
          textList: [
            {
              title: "",
              content: "采集标注驾驶员面部表情、驾驶员行为等图像视频，支持研发DMS，监测驾驶员的疲劳状态和驾驶舱危险动作等，减少车辆驾驶事故率。",
            },
           
          ],
        },
        {
          title: "4D标注",
          img: require("../assets/img/sjfw/a3.webp"),
          textList: [
            {
              title: "",
              content:
                "面向BEV感知",
            },
            {
              title: "",
              content:
                "3D重建技术（时序、图像）",
            },
            {
              title: "",
              content:
                "5千万点以上的静态物体标注，包括车道线、路面标识",
            },
            {
              title: "",
              content:
                "曲线拟合（平滑处理自动补点）",
            },
          ],
        },
        {
          title: "多传感器融合标注",
          img: require("../assets/img/sjfw/a4.webp"),
          textList: [
            {
              title: "",
              content:
                "多个激光雷达、环视周视相机、毫米波雷达",
            },
            {
              title: "",
              content:
                "速度标注与选取",
            },
            {
              title: "",
              content:
                "连续帧跟踪以及实例级别分割跟踪",
            }
          ],
        },
        {
          title: "图像标注",
          img: require("../assets/img/sjfw/a5.webp"),
          textList: [
            {
              title: "",
              content:
                "支持像素级精度的全景语义分割",
            },
            {
              title: "",
              content:
                "灵活的对象属性表单支持",
            },
            {
              title: "",
              content:
                "复杂的应用场景",
            },
            {
              title: "",
              content:
                "点、线、框混合标注是视觉全结构化必备工具",
            },
          ],
        },
        {
          title: "鱼眼图像标注",
          img: require("../assets/img/sjfw/a6.webp"),
          textList: [
            {
              title: "",
              content: "对鱼眼镜头采集的图像进行标注，提高采集和标注效率。",
            },
           
          ],
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.sjcj {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 450px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2{
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px ;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card-ys{
      width:448px;
      height:178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top:24px;
      .t1{
        font-size:20px;
        color: #25282a;
        margin-bottom: 16px;
      }.t2{
        font-size:16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 405px;

      margin: 0 0 48px;
      .contents {
        padding: 24px;
        height: 228px;
        background-color: #eceff0;
        border-radius: 0 0 8px 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          line-height: 1.5;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    cursor: pointer;
    width: 250px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
    .title-1{
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
    }
    .title-2{
      font-size:16px;
      line-height: 1.5;
    }
    li{
      margin-left: 24px;
      line-height: 1.5;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
